<template>
  <Modal
    id="loader"
    v-model="isShow"
    :maskClosable="false"
    :closable="false"
    :footer="null"
    name="loader-modal"
    class="loader-modal"
    dialogClass="dialog-modal"
    wrapClassName="loader-modal-wrap"
    :maskStyle="{ backgroundColor: 'rgba(0, 0, 0, 0.72)' }"
  >
    <img width="300" src="@/assets/rentalios.white.loader.gif" />
    <div v-if="textInfo">
      {{ textInfo }}
    </div>
  </Modal>
</template>

<script>
import { Modal } from 'ant-design-vue'

export default {
  name: 'LoaderModal',
  components: {
    Modal
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    textInfo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.loader-modal ::v-deep .vm--modal {
  padding: 24px 0;
}
::v-deep .dialog-modal .ant-modal-content {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>

<style>
.loader-modal-wrap .ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.72) !important;
}
</style>
